import { render } from "./LicenseDetails.vue?vue&type=template&id=45c27a6a&scoped=true&ts=true"
import script from "./LicenseDetails.vue?vue&type=script&lang=ts"
export * from "./LicenseDetails.vue?vue&type=script&lang=ts"

import "./LicenseDetails.vue?vue&type=style&index=0&id=45c27a6a&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c27a6a"]])

export default __exports__